import * as React from 'react';

import Linkify from 'linkifyjs/react';

interface Props {
  children: React.ReactNode;
}

export const LinkableTextArea = ({ children }: Props): any => {
  const options = {
    target: {
      url: '_blank',
    },
    className: 'linkable-textarea-link',
  };

  if (typeof children === 'string') {
    return <Linkify options={options}>{children}</Linkify>;
  }
  return children;
};
